import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bbd226d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buttons" }
const _hoisted_2 = {
  key: 0,
  class: "buttons-left-inner"
}
const _hoisted_3 = { class: "main" }
const _hoisted_4 = {
  key: 0,
  class: "main-inner"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "class-name-unit" }, "組", -1))
const _hoisted_6 = { class: "class-name" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "class-name-unit" }, "組", -1))
const _hoisted_8 = { class: "buttons" }
const _hoisted_9 = {
  key: 0,
  class: "buttons-right-inner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSmallButton = _resolveComponent("BaseSmallButton")!
  const _component_EditableItemText = _resolveComponent("EditableItemText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RemoveButton = _resolveComponent("RemoveButton")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["class-list-table-row-item-container", { editing: _ctx.editing, hovering: _ctx.hovering }]),
    style: _normalizeStyle(_ctx.styles),
    onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMouseEnter && _ctx.onMouseEnter(...args))),
    onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.editing && _ctx.hovering)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_BaseSmallButton, {
              class: "button",
              "aria-label": "Move Up",
              width: 18,
              height: 18,
              icon: "chevron-up",
              "icon-size": 12,
              color: "dark-gray",
              "background-color-on-hover": "light-gray",
              "on-click": _ctx.onClickUpInternal
            }, null, 8, ["on-click"]),
            _createVNode(_component_BaseSmallButton, {
              class: "button",
              "aria-label": "Move Down",
              width: 18,
              height: 18,
              icon: "chevron-down",
              "icon-size": 12,
              color: "dark-gray",
              "background-color-on-hover": "light-gray",
              "on-click": _ctx.onClickDownInternal
            }, null, 8, ["on-click"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_EditableItemText, {
              class: "class-name editing",
              value: _ctx.data.name,
              editable: true,
              type: "input",
              "font-size": 14,
              "font-color": "black",
              "on-input": _ctx.onInputNameInternal
            }, null, 8, ["value", "on-input"]),
            _hoisted_5
          ]))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            class: "main-inner",
            to: `/class/details/${_ctx.data.classId}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.data.name), 1),
              _hoisted_7
            ]),
            _: 1
          }, 8, ["to"]))
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.editing && _ctx.hovering && _ctx.isDataNew)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_RemoveButton, {
              class: "button",
              "aria-label": "Delete",
              size: 18,
              color: "dark-gray",
              "background-color-on-hover": "light-gray",
              "on-click": _ctx.onClickRemove
            }, null, 8, ["on-click"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 38))
}